// @core/api/endpoints/document/list_pipeline_executions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPipelineExecutionsResponse,
} from '../../../types/document';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/document';

/**
 * List pipeline executions
 * Returns all pipeline executions for a document (active and historical).
 */
export async function ListPipelineExecutions(
  target_type: string,
  target_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPipelineExecutionsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/pipeline-executions`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.get<ListPipelineExecutionsResponse>(requestPath, { ...requestOptions, params });
}
